const buildConfig = {
  version: '30'
}

module.exports = buildConfig
